const royerStoreFinderSearchingIndicator = /** @type {HTMLElement}*/ (document.getElementById('royer-store-finder-map-searching-indicator'));
const storeCardTemplate = /** @type {HTMLTemplateElement}*/ (document.getElementById('store-card-template'));
const royerStoreFinderStoreListWrapper = /** @type {HTMLElement}*/ (document.querySelector('.royer-store-finder-store-list-wrapper'));
const royerStoreFinderListBtn = /** @type {HTMLButtonElement}*/ (document.querySelector('.royer-store-finder-list-btn'));
const royerStoreFinderMapBtn = /** @type {HTMLButtonElement}*/ (document.querySelector('.royer-store-finder-map-btn'));

const storeFinderB2CApi = getDivZeroWebPublicApi(DivZeroWebPublicApi.B2CWebsitePublicApi, false);

const MIN_ZOOM = 11;
const ROYER_ZOOM_LVL_ON_FLY = 14;
/** @type {Leaflet.Marker | null} */
var royerStoreSelectedMarker = null;
/** @type {String | null} */
var royerStoreSelectedKey = null;

var royerStoreFinderIsOpeningPopup = false;
var royerStoreFinderIsFlyingToStore = false;
var royerStoreFetchGeneration = 0;

/** @type {Bootstrap.Toast} */
var royerStoreFinderPostalCodeNotFoundToast;
/** @type {Bootstrap.Toast} */
var royerStoreFinderGeolocationBlockedToast;
/** @type {Bootstrap.Toast} */
var royerStoreFinderInvalidPostalCodeFormatToast;

window.addEventListener('DOMContentLoaded', () => {
  royerStoreFinderPostalCodeNotFoundToast = bootstrap.Toast.getOrCreateInstance(
      /** @type {HTMLElement}*/(document.getElementById('royer-store-finder-postal-code-not-found-toast'))
  );
  royerStoreFinderGeolocationBlockedToast = bootstrap.Toast.getOrCreateInstance(
      /** @type {HTMLElement}*/(document.getElementById('royer-store-finder-geolocation-blocked-toast'))
  );
  royerStoreFinderInvalidPostalCodeFormatToast = bootstrap.Toast.getOrCreateInstance(
      /** @type {HTMLElement}*/(document.getElementById('royer-store-finder-invalid-postal-code-format-toast'))
  );
});

/** @type {Swiper} */
let royerStoreFinderSwiper;
initSwiperAfterLibLoad(".royer-store-finder-page-wrapper", {
  // Optional parameters
  direction: "horizontal",
  shortSwipes: true,
  simulateTouch: false,
  slideToClickedSlide: false,
  slidesPerView: 'auto',
  slidesPerGroupAuto: false,
  spaceBetween: 24,
  loop: false,
  speed: 500,
  autoHeight: false,
  effect: "slide",
  allowSlideNext: false,
  allowTouchMove: false,
  on: {
  },
}).then(result => royerStoreFinderSwiper = result);

const royerStoreFinderMap = L.map('royer-store-finder-map').setView([45.42, -71.9], 12);

L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  attribution: '© OpenStreetMap contributors',
}).addTo(royerStoreFinderMap);

const markers = new Map();
const storeData = new Map();

royerStoreFinderMap.on('movestart', () => showSearchingIndicator());
royerStoreFinderMap.on('moveend', () => {
  if (!royerStoreFinderIsFlyingToStore) fetchAndRenderStores();
  royerStoreFinderIsFlyingToStore = false;
});
royerStoreFinderMap.on('zoomend', () => {
  const zoom = royerStoreFinderMap.getZoom();

  for (const [key, marker] of markers) {
    if (zoom < MIN_ZOOM) marker.remove();
    else marker.addTo(royerStoreFinderMap);
  }

  royerStoreFinderStoreListWrapper.classList.toggle('d-none', zoom < MIN_ZOOM);

  if (royerStoreFinderIsFlyingToStore) return;
  fetchAndRenderStores();
});

royerStoreFinderMap.whenReady(() => fetchAndRenderStores());

async function fetchAndRenderStores() {
  if (royerStoreFinderMap.getZoom() < MIN_ZOOM) return;
  const bounds = royerStoreFinderMap.getBounds();
  showSearchingIndicator();

  const generation = ++royerStoreFetchGeneration;

  try {
    const stores = await getStoreRetailersByBounds(
      bounds.getSouth(),
      bounds.getWest(),
      bounds.getNorth(),
      bounds.getEast()
    );

    // If a newer fetch has started or user clicked a card, discard this result
    if (generation !== royerStoreFetchGeneration) return;
    if (royerStoreFinderIsFlyingToStore) return;

    for (const store of stores) {
      const key = `${store.address?.clientCode}__${store.address?.adrCode}`;
      if (!storeData.has(key)) storeData.set(key, store);
    }

    renderStoreList();
    await renderMarkers(stores);
  } catch (e) {
    console.log(e);
    genericServerErrorToast.show();
  } finally {
    hideSearchingIndicator();
  }
}

function getStoreIcon() {
  return L.divIcon({
    className: undefined,
    html: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" class="royer-store-marker">
            <path d="M15.9999 1.71838C11.0655 1.71838 7.06554 5.71838 7.06554 10.6528C7.06554 10.6528 6.42554 16.0256 15.9999 30.2816C25.5743 16.0256 24.9343 10.6528 24.9343 10.6528C24.9343 5.71838 20.9343 1.71838 15.9999 1.71838Z"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.0971 10.6427H17.4817C18.0803 10.6427 18.3995 10.4398 18.4394 10.0339L18.5351 9.02334C18.583 8.50565 17.9446 8.35241 17.5456 8.35241H13.8147L13.5952 10.6427H16.0971ZM11.0534 6H18.9302C21.1089 6 22.1304 6.74548 21.9867 8.2323L21.7792 10.4315C21.6236 12.0467 19.397 12.9247 18.0922 12.9247L21.3084 17H17.2902L14.1339 12.9454H13.3758L12.9887 17H10L10.822 8.35241L10.8499 8.04179L11.0454 6H11.0534Z" fill="white"/>
        </svg>`,
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });
}

/**
 * 
 * @param {DivZeroWebPublicModels.RetailerStore[]} stores 
 */
async function renderMarkers(stores) {
  for (const store of stores) {

    if (!store.address) continue;

    const { adrCode, clientCode, latitude, longitude, name, street, city, postalCodeOrZip } = store.address;
    const key = `${clientCode}__${adrCode}`;

    if (markers.has(key) || !latitude || !longitude) continue;

    var phoneElStr = '';
    var websiteElStr = '';
    if (store.phoneNb) phoneElStr = `<a class="popup-phone" href="tel:${store.phoneNb}">${store.phoneNb}</a>`;
    if (store.websiteUrl) {
      const displayUrl = store.websiteUrl.replace(/^https?:\/\/(www\.)?/, '');
      websiteElStr = `<a class="popup-website" href="${store.websiteUrl}" target="_blank">${displayUrl}</a>`;
    }

    const popup = `
            <b class="popup-title">${name}</b>
            <p class="popup-adr-street">${street}</p>
            <p class="popup-adr-city-postcode">${city}, ${postalCodeOrZip}</p>
            ${phoneElStr}
            ${websiteElStr}
        `;
    //Inside the loop so we can change the icon per store in the future (for premium retailer stuff or something)
    const customIcon = getStoreIcon();

    const marker = L.marker([latitude, longitude], { icon: customIcon })
      .bindPopup(popup, { maxWidth: 256, minWidth: 200 })
      .addTo(royerStoreFinderMap);

    marker.on('click', () => {
      if (royerStoreSelectedMarker && royerStoreSelectedMarker !== marker) {
        getStoreMarkerSvgEl(royerStoreSelectedMarker)?.classList.remove('selected');
      }
      royerStoreSelectedMarker = marker;
      getStoreMarkerSvgEl(marker)?.classList.add('selected');
      updateSelectedCard(key);
    });

    marker.on('popupclose', () => {
      if (royerStoreFinderIsOpeningPopup) return;
      getStoreMarkerSvgEl(marker)?.classList.remove('selected');
      royerStoreSelectedMarker = null;
      updateSelectedCard(null);
    });

    markers.set(key, marker);
    //Reduces lag and looks a bit pretty anyways
    await sleep(30);
  }
}

/**
 * 
 * @param {Leaflet.Marker} marker 
 * @returns 
 */
function getStoreMarkerSvgEl(marker) {
  return /** @type {HTMLElement | null} */ (marker.getElement()?.querySelector('.royer-store-marker'));
}

function useCurrentLocationForSearch() {
  navigator.geolocation.getCurrentPosition(
    async (position) => {
      royerStoreFinderMap.flyTo([position.coords.latitude, position.coords.longitude], ROYER_ZOOM_LVL_ON_FLY, {
        duration: 1.5,
        easeLinearity: 0.5,
      });
    },
    (error) => {
      royerStoreFinderGeolocationBlockedToast.show();
    }
  );
}

/**
 * @param {HTMLInputElement} searchInput
 */
async function updateSearchBtnClicked(searchInput) {
  const postalCode = searchInput.value.replaceAll(' ', '').toUpperCase();
  if (postalCode.length == 6 || postalCode.length == 7) {
    try {
      //countryCode is a global variable set in theme.liquid
      var result = await getCoordsFromPostalCode(countryCode, postalCode);

      //The API returns null when the postal code isn't found
      if (result?.latitude && result?.longitude) {
        royerStoreFinderMap.flyTo([result.latitude, result.longitude], ROYER_ZOOM_LVL_ON_FLY, {
          duration: 1.5,
          easeLinearity: 0.5,
        });
      }
      else {
        royerStoreFinderPostalCodeNotFoundToast.show();
      }
    } catch (e) {
      console.log(e);
      genericServerErrorToast.show();
    }
  } else {
    royerStoreFinderInvalidPostalCodeFormatToast.show();
  }
}

/**
 * @param {String} countryCode
 * @param {String} postalCode
 * 
 * 
 */
async function getCoordsFromPostalCode(countryCode, postalCode) {
  return await storeFinderB2CApi.b2CWebsitePublicGetCoordsByPostalCode({
    countryCode: countryCode,
    postalCode: postalCode,
  });
}

/**
 * 
 * @param {Number} south 
 * @param {Number} west 
 * @param {Number} north 
 * @param {Number} east 
 * @returns 
 */
async function getStoreRetailersByBounds(south, west, north, east) {
  return await storeFinderB2CApi.b2CWebsitePublicGetRetailerStoresInArea({ south, west, north, east });
}

function showSearchingIndicator() {
  royerStoreFinderSearchingIndicator.classList.remove('d-none');
}

function hideSearchingIndicator() {
  royerStoreFinderSearchingIndicator.classList.add('d-none');
}

/**
 * 
 * @param {Number} lat1 
 * @param {Number} lng1 
 * @param {Number} lat2 
 * @param {Number} lng2 
 * @returns 
 */
function getDistanceKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function renderStoreList() {
  const center = royerStoreFinderMap.getCenter();

  const bounds = royerStoreFinderMap.getBounds();

  // Distance from center to corner of the visible area
  const visibleRadius = getDistanceKm(
    center.lat, center.lng,
    bounds.getNorth(), bounds.getEast()
  );

  const zoom = royerStoreFinderMap.getZoom();
  const cutoffMultiplier = Math.max(1, 5 - (zoom - MIN_ZOOM) * 0.3);
  const cutoffRadius = visibleRadius * cutoffMultiplier;

  const sorted = [...storeData.entries()]
    .map(([key, store]) => ({
      key,
      store,
      dist: getDistanceKm(center.lat, center.lng, store.address.latitude, store.address.longitude)
    }))
    //Cutting of the stores too far away from the view
    .filter(({ dist }) => dist <= cutoffRadius)
    .sort((a, b) => a.dist - b.dist);

  royerStoreFinderStoreListWrapper.innerHTML = '';

  for (const { key, store, dist } of sorted) {
    const { name, street, city, postalCodeOrZip, placeId } = store.address;
    const distStr = dist < 1 ? `${Math.round(dist * 1000)} m` : `${dist.toFixed(1)} km`;
    const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(name)}&destination_place_id=${store.placeId}`;

    const card = /** @type {HTMLElement}*/ (/** @type {HTMLElement}*/ (storeCardTemplate.content.cloneNode(true)).querySelector('.store-card'));

    card.dataset.key = key;
    card.addEventListener('click', () => storeCardClicked(key));

    const storeCardNameEl = /** @type {HTMLElement}*/ (card.querySelector('.store-card-name'));
    storeCardNameEl.textContent = name;
    const storeCardAddressEl = /** @type {HTMLElement}*/ (card.querySelector('.store-card-address'));
    storeCardAddressEl.innerHTML = `${street}<br>${city}, ${postalCodeOrZip}`;
    const storeCardDistanceEl = /** @type {HTMLElement}*/ (card.querySelector('.store-card-dist'));
    storeCardDistanceEl.textContent = distStr;
    const storeCardDirectionLinkEl = /** @type {HTMLLinkElement}*/ (card.querySelector('.store-card-directions-btn'));
    storeCardDirectionLinkEl.href = mapsUrl;

    const phoneEl = /** @type {HTMLLinkElement}*/ (card.querySelector('.store-card-phone'));
    if (store.phoneNb) {
      phoneEl.href = `tel:${store.phoneNb}`;
      phoneEl.textContent = store.phoneNb;
    } else {
      phoneEl.remove();
    }

    const websiteEl = /** @type {HTMLLinkElement}*/ (card.querySelector('.store-card-website'));
    if (store.websiteUrl) {
      websiteEl.href = store.websiteUrl;
      websiteEl.textContent = store.websiteUrl.replace(/^https?:\/\/(www\.)?/, '');
    } else {
      websiteEl.remove();
    }

    royerStoreFinderStoreListWrapper.appendChild(card);
  }

  if (royerStoreSelectedKey) {
    const card = /** @type {HTMLElement}*/ (royerStoreFinderStoreListWrapper.querySelector(`.store-card[data-key="${royerStoreSelectedKey}"]`));
    if (card) {
      card.classList.add('selected');
      royerStoreFinderStoreListWrapper.scrollTo({ top: card.offsetTop - royerStoreFinderStoreListWrapper.offsetTop, behavior: 'instant' });
    }
  }
}

/**
 * 
 * @param {String} key 
 * @returns 
 */
function storeCardClicked(key) {
  const store = storeData.get(key);
  const marker = markers.get(key);
  if (!store || !marker) return;

  const { latitude, longitude } = store.address;

  royerStoreFinderIsFlyingToStore = true;
  royerStoreFetchGeneration++; // invalidate any in-flight fetch
  royerStoreFinderMap.flyTo([latitude, longitude], ROYER_ZOOM_LVL_ON_FLY, { duration: 0.5, easeLinearity: 0.5 });

  //When it's done flying to the point open the popup
  royerStoreFinderMap.once('moveend', () => {
    royerStoreFinderIsOpeningPopup = true;
    //Disabling autoPan for this otherwise it triggers a second mouveend event which causes the store list to refresh when it shouldn't
    marker.getPopup().options.autoPan = false;
    marker.openPopup();
    setTimeout(() => {
      marker.getPopup().options.autoPan = true;
      royerStoreFinderIsOpeningPopup = false;
    }, 0);
  });

  if (royerStoreSelectedMarker && royerStoreSelectedMarker !== marker) {
    getStoreMarkerSvgEl(royerStoreSelectedMarker)?.classList.remove('selected');
  }
  royerStoreSelectedMarker = marker;
  getStoreMarkerSvgEl(marker)?.classList.add('selected');
  updateSelectedCard(key);
}

/**
 * @param {String | null} key
 */
function updateSelectedCard(key) {
  royerStoreSelectedKey = key;
  document.querySelectorAll('.store-card').forEach(el => el.classList.remove('selected'));
  if (key) {
    const card = /** @type {HTMLElement}*/ (document.querySelector(`.store-card[data-key="${key}"]`));
    card?.classList.add('selected');
    if (card) {
      royerStoreFinderStoreListWrapper.scrollTo({ top: card.offsetTop - royerStoreFinderStoreListWrapper.offsetTop, behavior: 'smooth' });
    }
  }
}

/**
 * 
 * @param {HTMLButtonElement} btnClicked 
 */
function updateStoreFinderSlider(btnClicked) {
  if (btnClicked == royerStoreFinderListBtn) {
    royerStoreFinderMapBtn.classList.remove("active");
    royerStoreFinderListBtn.classList.add("active");
    royerStoreFinderSwiper.allowSlideNext = true;
    royerStoreFinderSwiper.allowSlidePrev = true;
    royerStoreFinderSwiper.slideTo(0)
  }
  else if (btnClicked == royerStoreFinderMapBtn) {
    royerStoreFinderMapBtn.classList.add("active");
    royerStoreFinderListBtn.classList.remove("active");
    royerStoreFinderSwiper.allowSlideNext = true;
    royerStoreFinderSwiper.allowSlidePrev = true;
    royerStoreFinderSwiper.slideTo(1)
  }
}